export default __webpack_public_path__ + "724ce1c701600efdaa84140eed7293a1.svg";